<template>
  <el-table-column
    prop="is_billable"
    sortable="custom"
    label="Számlázandó"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.is_billable ? 'Igen' : 'Nem' }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'is_billable',
  };
</script>
